// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__fhv5D","tech":"style_tech__UwiOP","map_container":"style_map_container__7xxMN"};